export default __webpack_public_path__ + "static/media/scratch.b049ff57.png";